import React, { useState } from "react";
import { IconButton } from "@mui/material";
import { ContentCopyOutlined } from "@mui/icons-material";

const CopyToClipboard = ({ text, overrideCopy, color }) => {
    const [isCopied, setIsCopied] = useState(false);

    const handleCopy = () => {
        if ("clipboard" in navigator) {
            navigator.clipboard.writeText(overrideCopy || text);
        } else {
            document.execCommand("copy", true, overrideCopy || text);
        }

        setIsCopied(true);
        setTimeout(() => {
            setIsCopied(false);
        }, 2000);
    };

    return (
        <div
            style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            }}
        >
            <span
                style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: "100%",
                }}
            >
                {text}
            </span>
            <IconButton
                onClick={handleCopy}
                size="small"
                style={{ padding: "0", marginLeft: "10px" }}
            >
                <ContentCopyOutlined
                    style={{
                        color: isCopied ? "#4caf50" : color || "#33333340",
                        transition: "all .3s ease",
                        fontSize: "1rem",
                    }}
                />
            </IconButton>
        </div>
    );
};

export default CopyToClipboard;
